<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :params="params"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["id"],
  created() {
    this.itemLink += `/${this.id}/service_permissions`;
    this.setLink += `/${this.id}/service_permissions`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: "col-12 col-md-6",
          label: "Основная (цена/лимит)",
          labelKey: "main_price_limit",
          key: "price_fix",
          type: "field",
        },

        {
          col: "col-12 col-md-6",
          label: "Доп. цена (цена/лимит/%)",
          labelKey: "price_limit_percent",
          key: "price_percent",
          type: "field",
        },
        {
          col: " col-12 col-md-12",
          key: "rate",
          label: "Допустимый рейтинг",
          labelKey: "rate_access",
          type: "static_radio",
          default: "0",
          items: [
            { id: "0", title: "0" },
            { id: "1", title: "1" },
            { id: "2", title: "2" },
            { id: "3", title: "3" },
            { id: "4", title: "4" },
            { id: "5", title: "5" },
          ],
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_service_permission",
      itemLink: "users",
      setLink: "users",
      columns: [
        {
          full: true,
          key: "service",
          title: "Название сервиса",
          object: "name",
          disableLink: true,
        },
        {
          full: true,
          key: "rate",
          title: "Допустимый рейтинг",
        },
        {
          full: true,
          title: "Доп. лимит",
          key: "price_percent",
        },
        {
          full: true,
          title: "Основной лимит",
          key: "price_fix",
        },
        {
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
